import React, { useMemo } from "react";

export const ImageComp = (props) => {
    const { source, style, resizeMode, ...restProps } = props;

    // Memoize the style to avoid unnecessary recalculations
    const customStyle = useMemo(() => {
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    }, [style]);

    const objectFit = customStyle?.objectFit || resizeMode;

    // Return null if the source is not provided
    if (!source || typeof source !== "string") {
        console.warn("ImageComp: 'source' is required and should be a string.");
        return null;
    }

    return (
        <img src={source} style={{...customStyle, objectFit: objectFit}} {...restProps} />
    );
};

